document.addEventListener("DOMContentLoaded", function () {
  // Mobile Dashboard Reordering Function
  function handleMobileDashboardReordering() {
    const accountWrapper = document.querySelector(".account__wrapper");
    const accountSidebar = document.querySelector(".account__sidebar");
    const accountContent = document.querySelector(".account__content");
    const dashboardSections = document.querySelector(".dashboard-sections");

    if (
      !accountWrapper ||
      !accountSidebar ||
      !accountContent ||
      !dashboardSections
    ) {
      return;
    }

    // Check if we're on mobile - EXACTLY match CSS breakpoint
    function isMobile() {
      return window.innerWidth <= 767.98;
    }

    function reorganizeForMobile() {
      // Clean up any existing mobile containers first
      const existingRemainingContainer = document.querySelector(
        ".dashboard-sections-remaining"
      );
      if (existingRemainingContainer) {
        existingRemainingContainer.remove();
      }

      // Reset all sections to be visible in the original container
      const allSections =
        dashboardSections.querySelectorAll(".dashboard-section");
      allSections.forEach((section) => {
        section.style.display = "";
      });

      if (!isMobile()) {
        // Desktop layout - reset to original flexbox row layout
        // Remove mobile ready class for desktop
        document.body.classList.remove("js-mobile-reorder-ready");

        accountWrapper.style.display = "flex";
        accountWrapper.style.flexDirection = "row";
        accountSidebar.style.order = "";
        accountContent.style.order = "";

        return;
      }

      // Mobile layout - create the new structure
      const activeSection = dashboardSections.querySelector(
        ".dashboard-section.active"
      );

      if (!activeSection) {
        return;
      }

      // Find the index of the active section
      const activeSectionIndex = Array.from(allSections).indexOf(activeSection);

      // Create NEW container for remaining sections (sections after the active one)
      const remainingContainer = document.createElement("div");
      remainingContainer.classList.add("dashboard-sections-remaining");
      accountWrapper.appendChild(remainingContainer);

      // Move sections after the active section to the remaining container
      let movedSections = 0;
      allSections.forEach((section, index) => {
        if (index > activeSectionIndex) {
          const clonedSection = section.cloneNode(true);

          // Copy event listeners to the cloned section if needed
          const originalLinks = section.querySelectorAll("a");
          const clonedLinks = clonedSection.querySelectorAll("a");

          originalLinks.forEach((originalLink, linkIndex) => {
            if (clonedLinks[linkIndex]) {
              clonedLinks[linkIndex].addEventListener("click", function (e) {
                // Let the link navigate normally
              });
            }
          });

          remainingContainer.appendChild(clonedSection);
          section.style.display = "none";
          movedSections++;
        }
      });

      // Set mobile layout: sections up to active, content, remaining sections
      accountWrapper.style.display = "flex";
      accountWrapper.style.flexDirection = "column";

      // Set orders for mobile layout
      accountSidebar.style.order = "1"; // Sections up to and including active
      accountContent.style.order = "2"; // Content second
      remainingContainer.style.order = "3"; // Remaining sections after active

      // Add class to indicate JS mobile reordering is complete
      document.body.classList.add("js-mobile-reorder-ready");
    }

    // Initial setup with delay to ensure DOM is ready
    setTimeout(() => {
      reorganizeForMobile();
    }, 50);

    // Listen for window resize with proper cleanup and debouncing
    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        reorganizeForMobile();
      }, 100);
    });

    // Also listen for orientation change on mobile devices
    window.addEventListener("orientationchange", function () {
      setTimeout(() => {
        reorganizeForMobile();
      }, 300);
    });
  }

  // Initialize mobile reordering
  handleMobileDashboardReordering();
});
